import type { ReactNode } from 'react'
import { useSessionQuery } from '@/lib/session'

export function SessionBootstrapper({ children }: { children: ReactNode }) {
  useSessionQuery()
  return <>{children}</>
}
